import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getTransferDriverList,
	addNewTransferDriver,
	updateTransferDriver,
	deleteTransferDriver,
	getTransferDriver,
} from '../transferDriver/thunk';

export const initialState = {
	itemTransferDriverList: [],
	itemTransferDriverDetail: null,
	isTransferDriverLoading: false,
	isTransferDriverSuccess: false,

	transferDriverList: [],
	transferDriverListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const TransferDriverSlice = createSlice({
	name: 'TransferDrivers',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getTransferDriver.fulfilled, (state, action) => {
			state.isTransferDriverLoading = false;
			state.isTransferDriverSuccess = true;
			state.itemTransferDriverDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getTransferDriver.pending, state => {
			state.isTransferDriverLoading = true;
			state.isTransferDriverSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getTransferDriver.rejected, (state, action) => {
			state.isTransferDriverLoading = false;
			state.isTransferDriverSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getTransferDriverList.pending, state => {
			state.isTransferDriverSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getTransferDriverList.fulfilled, (state, action) => {
			state.itemTransferDriverList = action.payload;
			state.transferDriverList = action.payload;
			state.isLoadingList = false;
			state.isTransferDriverSuccess = true;

			let transferDriverListSelect = [];
			action.payload.map(item =>
				transferDriverListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.transferDriverListSelect = transferDriverListSelect;
		});
		builder.addCase(getTransferDriverList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isTransferDriverSuccess = true;
		});
		builder.addCase(addNewTransferDriver.fulfilled, (state, action) => {
			state.itemTransferDriverList.push(action.payload);
			state.transferDriverList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewTransferDriver.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewTransferDriver.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateTransferDriver.fulfilled, (state, action) => {
			state.itemTransferDriverList = state.itemTransferDriverList.map(transferDriver =>
				transferDriver.transferDrivername === action.payload.old_transferDriver
					? { ...transferDriver, ...action.payload.updated_transferDriver }
					: transferDriver
			);
			state.transferDriverList = state.transferDriverList.map(transferDriver =>
				transferDriver._id.toString() === action.payload._id.toString()
					? { ...transferDriver, ...action.payload }
					: transferDriver
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateTransferDriver.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateTransferDriver.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteTransferDriver.fulfilled, (state, action) => {
			state.itemTransferDriverList = current(state.itemTransferDriverList).filter(
				item => item._id !== action.payload._id
			);
			state.transferDriverList = current(state.transferDriverList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteTransferDriver.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteTransferDriver.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
	},
});

export const { setRequireCloseModal } = TransferDriverSlice.actions;

export default TransferDriverSlice.reducer;